module.exports = __webpack_public_path__ + "img/pot1.1478658c.svg";